import { screenSizeDetection as d } from "@sunrise/shared";
import { defineComponent as l, computed as o, ref as p } from "vue";
import c from "./index22.js";
import f from "./index31.js";
import u from "./index170.js";
const t = 12, C = l({
  name: "HydratedLinkList",
  components: {
    MsHeadline: u,
    CsLinkGroup: f,
    CsExpander: c
  },
  props: {
    links: {
      type: Array,
      default: () => []
    },
    headline: String,
    isInVIM: Boolean,
    hasMaxColumns: Boolean
  },
  setup(n) {
    const { isScreenM: s } = d(), i = o(() => n.links.length > t), e = p(!1), r = o(
      () => e.value ? n.links : n.links.slice(0, t)
    );
    function a(m) {
      e.value = m;
    }
    return {
      computedLinks: r,
      isExpanded: e,
      showExpander: i,
      isScreenM: s,
      onUpdateExpanded: a
    };
  }
});
export {
  C as default
};
